import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Card from 'components/inputs/Card';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { RiChargingPile2Line } from 'react-icons/ri';
import { GiLogicGateAnd } from 'react-icons/gi';
import { BsPlug, BsChevronDown, BsChevronUp, BsDownload } from 'react-icons/bs';
import { FiZapOff, FiRefreshCcw } from 'react-icons/fi';
import { GoStop, GoPlug } from 'react-icons/go';
import { MdPowerOff } from 'react-icons/md';
import Select from 'components/inputs/Select';
import { BiSearch } from 'react-icons/bi';
import { API } from 'api';
import ReactPagination from 'components/general/ReactPagination';
import fileDownload from 'js-file-download';
import moment from 'moment';

/* eslint-disable react/prop-types */
const ChargerRow = ({ charger }) => {
  const [expanded, setExpanded] = useState(false);

  let issueAge = '-';
  if ((charger.charger_status === 'Unavailable' || charger.charger_status === 'Faulted') && charger.lastStatusUpdatedAt) {
    const issueBase = moment(charger.lastStatusUpdatedAt).utc(true);
    const issueAgeInMs = moment().utc(true).diff(issueBase);
    const duration = moment.duration(issueAgeInMs);
    if (issueAgeInMs >= 0) {
      issueAge = `${Math.floor(duration.asDays())} days ${String(duration.hours()).padStart(2, '0')}:${String(duration.minutes()).padStart(
        2,
        '0'
      )}:${String(duration.seconds()).padStart(2, '0')}`;
    }
  }

  return (
    <>
      <tr key={charger._id}>
        <td>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <RiChargingPile2Line color="#4975F2" size={20} />
            <span>{[charger.station?.state, charger.station?.city, charger.station?.name].filter(Boolean).join(' | ') || '-'}</span>
          </div>
        </td>
        <td>{charger.charger_id || charger.name || '-'}</td>
        <td>
          <div style={{ display: 'flex', gap: '6px' }}>
            {charger.plugs && charger.plugs.length > 0
              ? charger.plugs.map((p, idx) => (
                <span key={idx} title={p.external_max_electric_power ? `${p.external_max_electric_power / 1000}KW` : 'N/A'}>
                  <BsPlug
                    color={p.status === 'Available' ? '#14AC7F' : p.status === 'Charging' || p.status === 'In Use' ? '#4975F2' : '#FF8B00'}
                    size={22}
                  />
                </span>
              ))
              : '-'}
          </div>
        </td>
        <td>{charger.company?.cpo_code || '-'}</td>
        <td>{charger.zme?.name || '-'}</td>
        <td>{charger.station?.regional_manager || '-'}</td>
        <td>
          <span
            style={{
              display: 'inline-block',
              padding: '4px 14px',
              borderRadius: '20px',
              fontSize: '0.8rem',
              fontWeight: 600,
              color: '#fff',
              background:
                charger.charger_status === 'Available'
                  ? '#14AC7F'
                  : charger.charger_status === 'In Use'
                    ? '#4975F2'
                    : charger.charger_status === 'Faulted'
                      ? '#BE210B'
                      : charger.charger_status === 'Unavailable'
                        ? '#e8461e'
                        : charger.charger_status === 'PowerLoss'
                          ? '#BE210B'
                          : '#FF8B00',
            }}
          >
            {charger.charger_status || 'Unknown'}
          </span>
        </td>
        <td>{issueAge}</td>
        <td>
          {charger.lastStatusUpdatedAt
            ? new Date(charger.lastStatusUpdatedAt).toLocaleString('en-IN', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
            })
            : '-'}
        </td>
        <td style={{ textAlign: 'center' }}>
          <button
            onClick={() => setExpanded(!expanded)}
            style={{
              background: '#1c2e3c',
              color: '#c5d3de',
              border: '1px solid #1e3a4f',
              borderRadius: '4px',
              padding: '4px 8px',
              cursor: 'pointer',
            }}
          >
            {expanded ? <BsChevronUp /> : <BsChevronDown />}
          </button>
        </td>
      </tr>
      {expanded && (
        <tr>
          <td colSpan="10" style={{ padding: '0', border: 'none' }}>
            <div style={{ padding: '16px 24px', background: '#14202b', borderBottom: '1px solid #1e3a4f' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ color: '#6c8ea4', fontSize: '0.85rem' }}>
                    <th className="sub-table-header-cell">Connectors</th>
                    <th className="sub-table-header-cell">Status</th>
                    <th className="sub-table-header-cell">Error Code</th>
                    <th className="sub-table-header-cell">Vendor Error Code</th>
                    <th className="sub-table-header-cell">Error Info</th>
                    <th className="sub-table-header-cell">CPO Code</th>
                  </tr>
                </thead>
                <tbody>
                  {charger.plugs && charger.plugs.length > 0 ? (
                    charger.plugs.map((p, idx) => (
                      <tr key={idx} style={{ fontSize: '0.9rem', color: '#c5d3de' }}>
                        <td style={{ padding: '12px 8px' }}>
                          <span style={{ fontWeight: 'bold' }}>{String.fromCharCode(65 + idx)}</span>
                        </td>
                        <td style={{ padding: '12px 8px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <BsPlug
                              color={p.status === 'Available' ? '#14AC7F' : p.status === 'Charging' || p.status === 'In Use' ? '#4975F2' : '#FF8B00'}
                              size={20}
                            />
                            <span>{p.status || '-'}</span>
                          </div>
                        </td>
                        <td style={{ padding: '12px 8px' }}>{p.errorCode || p.error_code || '-'}</td>
                        <td style={{ padding: '12px 8px' }}>{p.errorMessage || p.vendorErrorCode || p.vendor_error_code || '-'}</td>
                        <td style={{ padding: '12px 8px' }}>{p.errorInfo || p.error_info || p.info || '-'}</td>
                        <td style={{ padding: '12px 8px' }}>{p.cpoErrorCode || p.cpo_error_code || charger.company?.cpo_code || '-'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ padding: '12px 8px', textAlign: 'center', color: '#6c8ea4' }}>
                        No connectors available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

const WarDashboard = () => {
  const [isLoader, setIsLoader] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedCapacities, setSelectedCapacities] = useState([]);
  const [stats, setStats] = useState({
    activeChargers: 0,
    capacities: {},
    statuses: {},
  });
  const [filters, setFilters] = useState({
    chargerType: [],
    tenants: [],
    region: null,
    zone: null,
    priority: null,
    zme: null,
  });

  const [allTenants, setAllTenants] = useState([]);
  const [regionsList, setRegionsList] = useState([]);
  const [zonesList, setZonesList] = useState([]);
  const [zmesList, setZmesList] = useState([]);

  useEffect(() => {
    // Fetch companies/tenants
    const fetchTenants = async () => {
      try {
        // Use general companies endpoint if possible
        const res = await API.getTenant({ limit: 1000, is_active: true });
        if (res && res.data && res.data.results) {
          console.log('Setting tenants to res.data.results', res.data.results);
          const activeTenants = res.data.results.filter((t) => t.is_active !== false);
          setAllTenants(activeTenants);
        } else if (res && res.data) {
          console.log('Setting tenants to res.data', res.data);
          const activeTenants = (Array.isArray(res.data) ? res.data : []).filter((t) => t.is_active !== false);
          setAllTenants(activeTenants);
        }
      } catch (e) {
        console.error('Failed to fetch tenants', e);
      }
    };
    fetchTenants();
  }, []);

  useEffect(() => {
    const fetchInitialFilters = async () => {
      try {
        const res = await API.getWarDashboardFilters();
        if (res && res.data && res.data.data) {
          const { regions, zones, zmes } = res.data.data;
          if (regions) {
            setRegionsList(regions.map((r) => ({ value: r, label: r })));
          }
          if (zones) {
            setZonesList(zones.map((z) => ({ value: z, label: z })));
          }
          if (zmes) {
            setZmesList(zmes.map((z) => ({ value: z._id, label: z.name })));
          }
        }
      } catch (e) {
        console.error('Failed to fetch initial filters', e);
      }
    };
    fetchInitialFilters();
  }, []);

  useEffect(() => {
    const fetchZonesForRegion = async () => {
      try {
        const params = {};
        if (filters.region) {
          params.region = filters.region;
        }
        const res = await API.getWarDashboardFilters(params);
        if (res && res.data && res.data.data && res.data.data.zones) {
          const formattedZones = res.data.data.zones.map((z) => ({ value: z, label: z }));
          setZonesList(formattedZones);

          // Reset currently selected zone to null if it's not valid for the new region
          if (filters.zone && !res.data.data.zones.includes(filters.zone)) {
            setFilters((prev) => ({ ...prev, zone: null }));
          }
        }
      } catch (e) {
        console.error('Failed to fetch zones for region', e);
      }
    };

    fetchZonesForRegion();
  }, [filters.region]);

  useEffect(() => {
    const fetchZmesForTenants = async () => {
      try {
        if (filters.tenants && filters.tenants.length > 0) {
          const params = { tenants: filters.tenants.join(',') };
          const res = await API.getWarDashboardFilters(params);
          if (res && res.data && res.data.data && res.data.data.zmes) {
            const formattedZmes = res.data.data.zmes.map((z) => ({ value: z._id, label: z.name }));
            setZmesList(formattedZmes);

            // Reset currently selected ZME if it's not valid for the new tenants
            if (filters.zme && !res.data.data.zmes.some((z) => z._id === filters.zme)) {
              setFilters((prev) => ({ ...prev, zme: null }));
            }
          }
        } else {
          setZmesList([]);
          if (filters.zme) {
            setFilters((prev) => ({ ...prev, zme: null }));
          }
        }
      } catch (e) {
        console.error('Failed to fetch ZMEs for tenants', e);
      }
    };

    fetchZmesForTenants();
  }, [filters.tenants]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const fetchDashboardData = async () => {
    setIsLoader(true);
    try {
      const params = {};
      if (filters.region && filters.region !== 'All') params.region = filters.region;
      if (filters.zone && filters.zone !== 'All') params.zone = filters.zone;
      if (filters.tenants && filters.tenants.length > 0) params.tenants = filters.tenants.join(',');
      if (filters.chargerType && filters.chargerType.length > 0) {
        params.chargerType = filters.chargerType
          .map((c) => (typeof c === 'string' ? c : c?.value))
          .filter(Boolean)
          .join(',');
      }
      if (filters.priority && filters.priority !== 'All') params.priority = filters.priority;
      if (filters.zme) params.zme = filters.zme;

      const response = await API.getWarDashboardStats(params);
      if (response && response.data && response.data.data) {
        const d = response.data.data;
        const newStats = {
          activeChargers: d.activeChargers || 0,
          capacities: {},
          statuses: {},
        };
        // Safely map capacityBreakdown array to object
        if (Array.isArray(d.capacityBreakdown)) {
          d.capacityBreakdown.forEach((item) => {
            newStats.capacities[item._id] = item.count;
          });
        }
        // Safely map statusBreakdown array to object
        if (Array.isArray(d.statusBreakdown)) {
          d.statusBreakdown.forEach((item) => {
            newStats.statuses[item._id] = item.count;
          });
        }
        setStats(newStats);
      }
    } catch (error) {
      console.error('Error fetching war dashboard stats:', error);
    } finally {
      setIsLoader(false);
    }
  };

  const [chargers, setChargers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResults, setTotalResults] = useState(0);

  const isDownloadDisabled = chargers.length === 0 || isDownloading;

  const fetchChargers = async (page = 1) => {
    setIsLoader(true);
    try {
      // Pass filtering data
      const params = {
        limit: 25,
        page: page,
      };
      if (filters.region && filters.region !== 'All') params.region = filters.region;
      if (filters.zone && filters.zone !== 'All') params.zone = filters.zone;
      if (filters.tenants && filters.tenants.length > 0) params.tenants = filters.tenants.join(',');
      if (filters.chargerType && filters.chargerType.length > 0) {
        params.chargerType = filters.chargerType
          .map((c) => (typeof c === 'string' ? c : c?.value))
          .filter(Boolean)
          .join(',');
      }
      if (filters.priority && filters.priority !== 'All') params.priority = filters.priority;
      if (selectedStatuses.length > 0) params.statuses = selectedStatuses.join(',');
      if (selectedCapacities.length > 0) params.capacities = selectedCapacities.join(',');
      if (searchTerm) params.search = searchTerm;
      if (filters.zme) params.zme = filters.zme;

      const response = await API.getWarDashboardChargers(params);
      if (response && response.data && response.data.data) {
        setChargers(response.data.data.results || []);
        setTotalResults(response.data.data.totalResults || 0);
        setTotalPages(response.data.data.totalPages || 1);
        setCurrentPage(page);
      }
    } catch (error) {
      console.error('Error fetching chargers:', error);
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, [filters]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchChargers(1);
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm, filters, selectedStatuses, selectedCapacities]);

  const handleStatusToggle = (key) => {
    setSelectedStatuses((prev) => (prev.includes(key) ? prev.filter((s) => s !== key) : [...prev, key]));
  };

  const handleCapacityToggle = (key) => {
    setSelectedCapacities((prev) => (prev.includes(key) ? prev.filter((s) => s !== key) : [...prev, key]));
  };

  const handleRefresh = () => {
    fetchDashboardData();
    fetchChargers(currentPage);
  };

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const params = {};
      if (filters.region && filters.region !== 'All') params.region = filters.region;
      if (filters.zone && filters.zone !== 'All') params.zone = filters.zone;
      if (filters.tenants && filters.tenants.length > 0) params.tenants = filters.tenants.join(',');
      if (filters.chargerType && filters.chargerType.length > 0) {
        params.chargerType = filters.chargerType
          .map((c) => (typeof c === 'string' ? c : c?.value))
          .filter(Boolean)
          .join(',');
      }
      if (filters.priority && filters.priority !== 'All') params.priority = filters.priority;
      if (selectedStatuses.length > 0) params.statuses = selectedStatuses.join(',');
      if (selectedCapacities.length > 0) params.capacities = selectedCapacities.join(',');
      if (searchTerm) params.search = searchTerm;
      if (filters.zme) params.zme = filters.zme;

      const response = await API.downloadWarDashboardChargers(params);
      if (response && response.data) {
        fileDownload(response.data, 'Charger Status.xlsx');
      }
    } catch (error) {
      console.error('Error downloading charger list:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <LayoutContainer>
      <AdminHeader title="Maintenance Team War Dashboard" />
      <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation={true}>
        <div className="page-content-wrapper scrollable">
          {/* Top Active Chargers Header */}
          <div
            className="wise_status"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: '15px' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', fontSize: '1rem', fontWeight: 'bold' }}>
              Active Chargers - All
              <span style={{ fontSize: '1.5rem', marginLeft: '10px', color: '#14ac7f' }}>{stats.activeChargers}</span>
            </div>
            <button
              onClick={handleRefresh}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: '#e8461e',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                padding: '8px 16px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '0.9rem',
              }}
            >
              <FiRefreshCcw size={16} /> Refresh
            </button>
          </div>

          <h5 style={{ marginBottom: '10px' }}>Pan India / Region Capacities</h5>
          <div className="status-blocks" style={{ marginBottom: '20px' }}>
            {[
              {
                key: '720KW',
                label: '720KW',
                count: stats.capacities?.['720KW'],
                icon: <RiChargingPile2Line color="#FF8B00" size={30} />,
                bg: '#ff8b001a',
              },
              {
                key: '360KW',
                label: '360KW',
                count: stats.capacities?.['360KW'],
                icon: <RiChargingPile2Line color="#4975F2" size={30} />,
                bg: '#3c7cdd1a',
              },
              {
                key: '240KW',
                label: '240KW',
                count: stats.capacities?.['240KW'],
                icon: <RiChargingPile2Line color="#14AC7F" size={30} />,
                bg: '#14ac7f1a',
              },
              {
                key: '180KW',
                label: '180KW',
                count: stats.capacities?.['180KW'],
                icon: <RiChargingPile2Line color="#FF8B00" size={30} />,
                bg: '#ff8b001a',
              },
              {
                key: '120KW',
                label: '120KW',
                count: stats.capacities?.['120KW'],
                icon: <RiChargingPile2Line color="#BE210B" size={30} />,
                bg: '#be210b21',
              },
              {
                key: '60KW',
                label: '60KW',
                count: stats.capacities?.['60KW'],
                icon: <RiChargingPile2Line color="#C9A11B" size={30} />,
                bg: '#c9a11b1a',
              },
              {
                key: '30KW',
                label: '30KW',
                count: stats.capacities?.['30KW'],
                icon: <RiChargingPile2Line color="#14AC7F" size={30} />,
                bg: '#14ac7f1a',
              },
              { key: 'GB/T', label: 'GB/T', count: stats.capacities?.['GB/T'], icon: <BsPlug color="#4975F2" size={30} />, bg: '#3c7cdd1a' },
              { key: 'AC 7.4', label: 'AC 7.4', count: stats.capacities?.['AC 7.4'], icon: <BsPlug color="#FF8B00" size={30} />, bg: '#ff8b001a' },
              { key: 'AC 3.3', label: 'AC 3.3', count: stats.capacities?.['AC 3.3'], icon: <BsPlug color="#14AC7F" size={30} />, bg: '#14ac7f1a' },
              { key: 'Other', label: 'Other', count: stats.capacities?.['Other'], icon: <BsPlug color="#BE210B" size={30} />, bg: '#be210b21' },
            ].map(({ key, count, label, icon, bg }) => (
              <div
                key={key}
                className="status-block"
                title={label}
                onClick={() => handleCapacityToggle(key)}
                style={
                  selectedCapacities.includes(key)
                    ? { outline: '2px solid rgba(255,255,255,0.5)', filter: 'brightness(1.15)', cursor: 'pointer' }
                    : { cursor: 'pointer' }
                }
              >
                <div className="breating-area" style={{ background: bg }}>
                  {isLoader ? <Skeleton circle={true} height={24} width={24} /> : icon}
                </div>
                <div className="status-info">
                  <h1 style={{ fontSize: '1.2rem' }}>{isLoader ? <Skeleton height={15} width={60} /> : count || 0}</h1>
                  <p style={{ fontSize: '0.8rem' }}>{isLoader ? <Skeleton height={15} width={60} /> : label}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Filters Bar Separated */}
          <div className="data-report--block" style={{ marginBottom: '20px' }}>
            <Card>
              <div className="data-report__inner">
                <div className="data-report__box">
                  <Row className="mb-0">
                    <Col md={3}>
                      <Select
                        label="Level 1: Charger Type"
                        isMulti={true}
                        options={[
                          { value: 'b2c', label: 'Open Chargers (B2C)' },
                          { value: 'hybrid', label: 'Open Hub (B2B Open Hubs)' },
                          { value: 'b2b', label: 'B2B Hubs (Dedicated)' },
                        ]}
                        placeholder="Select Charger Type (Multiple)"
                        value={filters.chargerType}
                        onChange={(val) => {
                          handleFilterChange('chargerType', val);
                          handleFilterChange('tenants', []);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Select
                        label="ZME"
                        isClearable={true}
                        options={zmesList}
                        placeholder="Select ZME"
                        value={filters.zme}
                        onChange={(val) => handleFilterChange('zme', val)}
                      />
                    </Col>
                    {filters.chargerType && filters.chargerType.length > 0 && (
                      <>
                        <Col md={3}>
                          <Select
                            label="Level 2: Select Tenants"
                            isMulti={true}
                            options={allTenants
                              .filter((t) =>
                                filters.chargerType.some(
                                  (ct) => (typeof ct === 'string' ? ct : ct?.value || '').toLowerCase() === (t?.mode || '').toLowerCase()
                                )
                              )
                              .map((t) => ({ value: t.id || t._id, label: t.name }))}
                            placeholder="Select Tenants (Multiple)"
                            value={filters.tenants}
                            onChange={(val) => handleFilterChange('tenants', val)}
                          />
                        </Col>
                        {filters.tenants && filters.tenants.length > 0 && (
                          <Col md={3}>
                            <Select
                              label="ZME"
                              isClearable={true}
                              options={zmesList}
                              placeholder="Select ZME"
                              value={filters.zme}
                              onChange={(val) => handleFilterChange('zme', val)}
                            />
                          </Col>
                        )}
                        <Col md={3}>
                          <Select
                            label="Region"
                            disableSort={true}
                            isClearable={true}
                            options={regionsList}
                            placeholder="Select Region"
                            value={filters.region}
                            onChange={(val) => handleFilterChange('region', val)}
                          />
                        </Col>
                        <Col md={3}>
                          <Select
                            label="Zone"
                            disableSort={true}
                            isClearable={true}
                            options={zonesList}
                            placeholder="Select Zone"
                            value={filters.zone}
                            onChange={(val) => handleFilterChange('zone', val)}
                          />
                        </Col>
                        <Col md={3}>
                          <Select
                            label="Priority"
                            options={[
                              { value: 'All', label: 'All' },
                              { value: 'Critical', label: 'Critical (> 3days)' },
                              { value: 'High', label: 'High (1-3 days)' },
                              { value: 'Medium', label: 'Medium (6-24 hours)' },
                              { value: 'Low', label: 'Low (0-6 hours)' },
                            ]}
                            placeholder="Select Priority"
                            value={filters.priority}
                            onChange={(val) => handleFilterChange('priority', val)}
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                </div>
              </div>
            </Card>
          </div>

          {/* Charger Statuses */}
          {(() => {
            return (
              <>
                <h5 style={{ marginBottom: '10px', marginTop: '20px' }}>Charger Statuses</h5>
                <div className="status-blocks" style={{ marginBottom: '30px' }}>
                  {[
                    {
                      key: 'In Use',
                      count: stats.statuses?.['In Use'],
                      label: 'In Use',
                      icon: <GiLogicGateAnd color="#4975F2" size={35} />,
                      bg: '#3c7cdd1a',
                    },
                    {
                      key: 'Available',
                      count: stats.statuses?.['Available'],
                      label: 'Available',
                      icon: <BsPlug color="#14AC7F" size={35} />,
                      bg: '#14ac7f1a',
                    },
                    {
                      key: 'Faulted',
                      count: stats.statuses?.['Faulted'],
                      label: 'Faulted',
                      icon: <GiLogicGateAnd color="#BE210B" size={35} />,
                      bg: '#be210b21',
                    },
                    {
                      key: 'Unavailable',
                      count: stats.statuses?.['Unavailable'],
                      label: 'Unavailable',
                      icon: <MdPowerOff color="#FF8B00" size={35} />,
                      bg: '#ff8b001a',
                    },
                    {
                      key: 'PowerLoss',
                      count: stats.statuses?.['PowerLoss'],
                      label: 'Power Loss',
                      icon: <FiZapOff color="#BE210B" size={35} />,
                      bg: '#be210b21',
                    },
                    {
                      key: 'Emergency Button Pressed',
                      count: stats.statuses?.['Emergency Button Pressed'],
                      label: 'Emergency Stop Pressed',
                      icon: <GoStop color="#C9A11B" size={35} />,
                      bg: '#c9a11b1a',
                    },
                    {
                      key: 'Under Voltage',
                      count: stats.statuses?.['Under Voltage'],
                      label: 'Under Voltage',
                      icon: <GoPlug color="#FF8B00" size={35} />,
                      bg: '#ff8b001a',
                    },
                    {
                      key: 'Over Voltage',
                      count: stats.statuses?.['Over Voltage'],
                      label: 'Over Voltage',
                      icon: <GoPlug color="#FF8B00" size={35} />,
                      bg: '#ff8b001a',
                    },
                    {
                      key: 'Ground Fault',
                      count: stats.statuses?.['Ground Fault'],
                      label: 'Ground Fault',
                      icon: <MdPowerOff color="#BE210B" size={35} />,
                      bg: '#be210b21',
                    },
                    {
                      key: 'Other Error Codes',
                      count: stats.statuses?.['Other Error Codes'],
                      label: 'Other Error Codes',
                      icon: <FiZapOff color="#FF8B00" size={35} />,
                      bg: '#ff8b001a',
                    },
                  ].map(({ key, count, label, icon, bg }) => (
                    <div
                      key={key}
                      className="status-block"
                      title={label}
                      onClick={() => handleStatusToggle(key)}
                      style={
                        selectedStatuses.includes(key)
                          ? { outline: '2px solid rgba(255,255,255,0.5)', filter: 'brightness(1.15)', cursor: 'pointer' }
                          : { cursor: 'pointer' }
                      }
                    >
                      <div className="breating-area" style={{ background: bg }}>
                        {isLoader ? <Skeleton circle={true} height={24} width={24} /> : icon}
                      </div>
                      <div className="status-info">
                        <h1>{isLoader ? <Skeleton height={15} width={80} /> : count || 0}</h1>
                        <p>{isLoader ? <Skeleton height={15} width={80} /> : label}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            );
          })()}

          {/* Charger List */}
          <div className="data-report--main">
            <div className="data-report--block">
              <Card>
                <div className="data-report__inner">
                  {/* Search Bar */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', padding: '0 4px', gap: '10px' }}>
                    <div
                      style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        background: '#15212b',
                        borderRadius: '8px',
                        padding: '8px 14px',
                        border: '1px solid #1e3a4f',
                        height: '42px',
                      }}
                    >
                      <BiSearch color="#6c8ea4" size={20} />
                      <input
                        type="text"
                        placeholder="Search by station name, OCPP ID, CPO code..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          flex: 1,
                          background: 'transparent',
                          border: 'none',
                          outline: 'none',
                          color: '#c5d3de',
                          fontSize: '0.9rem',
                          marginLeft: '10px',
                        }}
                      />
                    </div>
                    {/* Download Button */}
                    <button
                      onClick={handleDownload}
                      disabled={isDownloadDisabled}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: isDownloadDisabled ? '#2e3d4e' : '#14ac7f',
                        color: isDownloadDisabled ? '#6c8ea4' : '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        fontWeight: '600',
                        cursor: isDownloadDisabled ? 'not-allowed' : 'pointer',
                        fontSize: '0.9rem',
                        height: '42px',
                      }}
                    >
                      {isDownloading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                            style={{ width: '14px', height: '14px', marginRight: '5px' }}
                          ></span>
                          Downloading...
                        </>
                      ) : (
                        <>
                          <BsDownload size={16} /> Download Charger List
                        </>
                      )}
                    </button>
                  </div>

                  <div className="data-report__table">
                    <div className="table-responsive">
                      <table className="record-list-table">
                        <thead>
                          <tr className="charger-status-header">
                            <th>
                              <span>Station Name</span>
                            </th>
                            <th>
                              <span>OCPP ID</span>
                            </th>
                            <th>
                              <span>Connectors</span>
                            </th>
                            <th>
                              <span>CPO Code</span>
                            </th>
                            <th>
                              <span>ZME</span>
                            </th>
                            <th>
                              <span>Regional Manager</span>
                            </th>
                            <th>
                              <span>Status</span>
                            </th>
                            <th>
                              <span>Issue Age (days hh:mm:ss)</span>
                            </th>
                            <th>
                              <span>Last Status Updated</span>
                            </th>
                            <th style={{ width: '40px' }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {chargers.length === 0 ? (
                            <tr>
                              <td colSpan="10" style={{ textAlign: 'center', padding: '20px' }}>
                                {isLoader ? 'Loading chargers...' : 'No chargers found.'}
                              </td>
                            </tr>
                          ) : (
                            chargers.map((charger) => <ChargerRow key={charger._id} charger={charger} />)
                          )}
                        </tbody>
                      </table>
                    </div>
                    {!isLoader && chargers.length > 0 && (
                      <ReactPagination
                        currentPage={currentPage}
                        limit={25}
                        total={totalResults}
                        handlePageClick={(pageVal) => fetchChargers(pageVal.selected + 1)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                    )}
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </SkeletonTheme>
    </LayoutContainer>
  );
};

export default WarDashboard;
